const EVENT_CONFIG = {
  draft_saved: { kind: 'activity' },
  review_requested: { kind: 'review' },
  review_resubmitted: { kind: 'review' },
  delivered: { kind: 'status' },
  archived: { kind: 'status' },
  restored: { kind: 'status' },
  finalized: { kind: 'status' },
  property_detail_updated: { kind: 'activity', context: 'property' },
  property_document_uploaded: { kind: 'document', context: 'property' },
  property_document_downloaded: { kind: 'document', context: 'property' },
  property_document_deleted: { kind: 'document', context: 'property' },
  property_document_types_updated: { kind: 'document', context: 'property' },
  party_saved: { kind: 'activity', context: 'party' },
  party_removed: { kind: 'activity', context: 'party' },
  party_document_uploaded: { kind: 'document', context: 'party' },
  party_document_downloaded: { kind: 'document', context: 'party' },
  party_document_deleted: { kind: 'document', context: 'party' },
  party_document_types_updated: { kind: 'document', context: 'party' },
  sales_receipt_uploaded: {
    kind: 'document',
    context: 'receipt',
    label: 'RECEIPT_UPLOADED',
  },
  sales_receipt_downloaded: {
    kind: 'document',
    context: 'receipt',
    label: 'RECEIPT_DOWNLOADED',
  },
  sales_receipt_deleted: {
    kind: 'document',
    context: 'receipt',
    label: 'RECEIPT_DELETED',
  },
  delivery_recipients_updated: { kind: 'activity' },
  sales_receipt_ocr_saved: {
    kind: 'document',
    context: 'receipt',
    label: 'RECEIPT_OCR_SAVED',
  },
  sales_receipt_conflict_saved: {
    kind: 'document',
    context: 'receipt',
    label: 'RECEIPT_CONFLICT_SAVED',
  },
  sales_receipt_conflict_resolved: {
    kind: 'document',
    context: 'receipt',
    label: 'RECEIPT_CONFLICT_RESOLVED',
  },
  property_onus_analysis_applied: { kind: 'document', context: 'property' },
  property_onus_analysis_not_configured: {
    kind: 'document',
    context: 'property',
  },
  property_onus_analysis_failed: { kind: 'document', context: 'property' },
};

const historyKey = value =>
  value
    .toString()
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .toUpperCase();

export const salesHistoryInitials = name => {
  const parts = name.toString().trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '??';

  const surname = parts.slice(1).find(part => part.length > 2);
  return `${parts[0][0]}${surname?.[0] || ''}`.toUpperCase();
};

export const presentSalesHistoryEvent = event => {
  const eventType = event?.event_type || '';
  const config = EVENT_CONFIG[eventType] || { kind: 'activity' };
  const actorName = event?.actor?.name?.trim() || '';

  return {
    id: event?.id,
    key: event?.id || event?.sequence || `${eventType}-${event?.occurred_at}`,
    actorInitials: salesHistoryInitials(actorName),
    actorName,
    contextCode: config.context ? historyKey(config.context) : '',
    eventLabelCode: EVENT_CONFIG[eventType]
      ? config.label || historyKey(eventType)
      : 'UNKNOWN',
    kindCode: historyKey(config.kind),
    occurredAt: event?.occurred_at || '',
    reason: event?.reason || '',
  };
};
